import React, { useEffect, useState } from 'react';
import { Loading } from 'framework/ui/mui-builder';
import useUserRedirectService from './useUserRedirectService';
import useAuthenticatedUserService, { UserName } from 'infrastructure/security/authentication/authenticatedUserService';

const ProtectedRoute = ({ children }: any) => {
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState<Nullable<UserName>>(null);
  const { getUserName } = useAuthenticatedUserService();
  const { checkAuthenticationAndRedirectIfFailed } = useUserRedirectService();

  useEffect(() => {
    (async () => {
      await checkAuthenticationAndRedirectIfFailed();
      const name = await getUserName();
      setUserName(name);
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading || !userName) {
    return <Loading />;
  } else {
    return children;
  }
};

export default ProtectedRoute;
